export default {
  add: 'Agregar',
  added: 'Agregado',
  addMore: 'Agregar más',
  areYouSure: '¿Estás seguro?',
  cancel: 'Cancelar',
  cancelHabit: 'Cancelar hábito',
  changesToSync: 'changes to sync',
  clear: 'Eliminar',
  confirm: 'Confirmar',
  confirmExactTime: 'Confirmar Hora Exacta',
  copied: '¿Agregar contenido copiado a la lista?',
  custom: 'Personalizado',
  email: 'Email',
  every: 'Cada',
  everyMonth: 'cada mes',
  everyYear: 'cada año',
  gotcha: 'Entendido',
  habit: 'Hábito',
  inOneMonth: 'En un mes',
  iWouldLikeToBeAbleTo: 'Me gustaría ser capáz de…',
  justSwipe: 'Solo desliza',
  laterToday: 'Más tarde',
  leaveFeedback: 'Dejar un comentario',
  likeItRateIt: '¿Te gusta? ¡Deja tu reseña!',
  listname_deleted: 'Artículos Suprimidos',
  listname_done: 'Artículos Completados',
  listname_postponed: 'Después',
  listname_todo: 'Por hacer',
  login: 'Iniciar sesión',
  loginNow: 'Iniciar sesión',
  loginOrSignup: 'Iniciar sesión o registrarse',
  loginToSync: 'Iniciar sesión para sincronizar con otros dispositivos',
  nothingPlanned: 'All clear, no tasks planned yet!',
  logMeOutAnyway: 'Cerrar sesión de todos modos',
  movedTo: 'Movido para',
  nextWeek: 'La semana que viene',
  nextWeekend: 'El próximo fin de semana',
  noTasksLeft: '¡No te  quedan tareas!',
  notLoggedIn: 'No has iniciado sesión ',
  offlineMode: 'Modo Sin Conexión',
  ok: 'Ok',
  online: 'Online',
  openLink: 'Enlace abierto',
  password: 'Contraseña',
  profile: 'Perfil',
  recurring_day: 'Diario',
  recurring_month: 'Mensual',
  recurring_week: 'Semanal',
  recurring_year: 'Anual',
  save: 'Guardar',
  selectAll: 'Seleccionar Todo',
  sessionExpired: 'Sesión Expirada',
  signOut: 'Cerrar sesión',
  signup: 'Registrarse',
  specifyAnExactTime: 'Coloca una hora exacta',
  spreadTheLove: 'Esparce el amor',
  startAt: 'Principio',
  startByAddingATask: 'Comienza agregando una tarea',
  status_deleted: 'Suprimidos',
  status_done: 'Hecho',
  status_postponed: 'Después',
  status_todo: 'Por hacer',
  swipeToComplete: 'Desliza para completar',
  swipeToPlanForLater: 'Desliza para planear para después',
  themeSelector: 'Elija el tema',
  thisEvening: 'Esta noche',
  thisWeekend: 'Este fin de semana',
  tomorrow: 'Mañana',
  tomorrowEvening: 'Mañana por la noche',
  toTheLeft: 'A la izquierda',
  toTheRight: 'A la derecha',
  undo: 'Deshacer',
  updated: 'Actualizado',
  updatedScheduleTo: 'Hábito actualizado a',
  whatCanWeDoBetterPleaseLetUsKnow: '¿Qué podemos hacer major? Por favor haznoslo saber',
  youHaveUnsyncedChangesThatWillBeLost: 'Tienes cambios que no se han sincronizado y se perderán',
  youNeedToLoginAgain: 'Necesitas Iniciar sesión nuevamente',
  allowLysterCalendarAccess: 'Allow Lyster to access your calendars to get a full view of your day',
  allowNow: 'Allow Now',
  calendars: 'Calendars',
  hideUpcoming: 'Hide upcoming',
  showEntireDay: 'Show entire day',
  nextMeetingAt: 'Next meeting at',
  thingsLaterToday: 'things later today',
  allDoneGoodJob: 'All done, good job!',
  after: 'After',
  refresh: 'Refresh',
  empty: 'Nothing here yet, your move! :)',
  pleaseEnterValidEmail: 'Please enter a valid email',
  pleaseEnter6DigitCodeFromEmail: 'Please enter the 6-character code in the email you received',
  didntGetTheCodeQuestion: 'Didn\'t get the code?',
  pleaseTakeAMinuteToReviewAndAccept: 'Please take a minute to review our Terms of Service and Privacy Policy',
  proceed: 'Proceed',
  resendCode: 'Resend Code',
  pleaseReviewAndAcceptOur: 'Please review and accept our',
  privacyPolicy: 'Privacy Policy',
  termsOfService: 'Terms of Service',
  simplyEnterYourEmailAndWellSendYouALink: 'Simply enter your email and we\'ll send you a code. More secure - less to remember.',
  pleaseReviewAndAcceptToProceed: 'Please review and accept to proceed',
  weValueYourPrivacy: 'We Value Your Privacy',
  terms: 'Terms',
  allDay: 'All day',
  changedOrder: 'Changed order of tasks',
  today: 'Today',
  yesterday: 'Yesterday',
  last: 'Last',
  autoDarkMode: 'Auto Dark Mode',
  readingList: 'Reading List',
  automaticallyAddToSafariReadingList: 'Add links to Safari Reading List automatically',
  tipReadLaterOffline: 'Tip: Enable "Automatically Save Offline" in your Safari Settings to make links available offline',
  timingSettings: 'Timing settings',
  lysterPremiumComingSoon: 'Lyster Premium coming soon!',
  premium: 'Premium',
  premiumInfo: "We'll soon launch Schedulist! It will introduce categorization, integrations and collaboration while keeping the simplicity of Lyster",
  startEveningsAt: 'Start evenings at',
  startMorningsAt: 'Start mornings at',
  pleaseSpecifyATimeBetween: 'Please specify a time between',
};
